import _ from 'lodash';
import React, {FC} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {Dropdown} from '../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownList} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownList';
import {DropdownItem} from '../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemContent} from '../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {PopoverTransferProps} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {CalendarEventVersionShowAsTypesEnum} from '../../../models/api/calendarEventVersionModel';
import {StyledCalendarDropdownBoxCoordinator} from './calendarDropdownBoxBase';

/*
 * Props.
 */

interface CalendarShowAsDropdownBoxProps {
  showAs: CalendarEventVersionShowAsTypesEnum;
  onShowAsChange: (arg: CalendarEventVersionShowAsTypesEnum) => void;
  className?: string;
}

/*
 * Component.
 */

export const CalendarShowAsDropdownBox: FC<CalendarShowAsDropdownBoxProps> = (props) => (
  <StyledCalendarDropdownBoxCoordinator
    value={renderText(props.showAs)}
    renderDropdown={(popoverProps) => renderDropdown(popoverProps, props)}
    boxClassName={props.className}
  />
);

function renderDropdown(popoverProps: PopoverTransferProps, props: CalendarShowAsDropdownBoxProps) {
  return (
    <Dropdown {...popoverProps}>
      <DropdownList {...popoverProps}>
        {_(CalendarEventVersionShowAsTypesEnum)
          .values()
          .map((v) => renderItem(v, props))
          .value()}
      </DropdownList>
    </Dropdown>
  );
}

function renderItem(showAs: CalendarEventVersionShowAsTypesEnum, props: CalendarShowAsDropdownBoxProps) {
  const isChecked = showAs === props.showAs;
  return (
    <DropdownItem key={showAs} isChecked={isChecked} onSelect={() => props.onShowAsChange(showAs)}>
      <DropdownItemContent isChecked={isChecked}>{renderText(showAs)}</DropdownItemContent>
    </DropdownItem>
  );
}

function renderText(showAs: CalendarEventVersionShowAsTypesEnum) {
  switch (showAs) {
    case CalendarEventVersionShowAsTypesEnum.FREE:
      return <Trans id="calendar-show-as-free">Show as free</Trans>;
    default:
      return <Trans id="calendar-show-as-busy">Show as busy</Trans>;
  }
}
